import React from "react";
import ReactDOM from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";

import config from './config.json';

import App from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data will be considered "fresh" for 2 minutes, preventing re-fetches. 
      staleTime: 1000 * 60 * 2, // Using default staleTime: 0. 
      // Prevents re-fetching when you click back onto the browser window.
      refetchOnWindowFocus: false, 
    },
  },
});

// Read Cognito config from config.json
const cognitoConfig = config.cognito;

const oidcConfig = {
  authority: `https://${cognitoConfig.hostedUIDomain}`,
  client_id: cognitoConfig.clientId,
  redirect_uri: cognitoConfig.redirectUri,
  post_logout_redirect_uri: cognitoConfig.postLogoutRedirectUri,
  response_type: "code",
  scope: cognitoConfig.scope,
  automaticSilentRenew: true,
  metadata: {
    issuer: `https://cognito-idp.${cognitoConfig.userPoolId.split('_')[0]}.amazonaws.com/${cognitoConfig.userPoolId}`,
    authorization_endpoint: `https://${cognitoConfig.hostedUIDomain}/oauth2/authorize`,
    token_endpoint: `https://${cognitoConfig.hostedUIDomain}/oauth2/token`,
    userinfo_endpoint: `https://${cognitoConfig.hostedUIDomain}/oauth2/userinfo`,
    jwks_uri: `https://cognito-idp.${cognitoConfig.userPoolId.split('_')[0]}.amazonaws.com/${cognitoConfig.userPoolId}/.well-known/jwks.json`,
    end_session_endpoint: `https://${cognitoConfig.hostedUIDomain}/logout`, // Corrected typo: removed extra "https"
  },
  loadUserInfo: false, // Let's rely on the ID token for user info for now
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <StyledEngineProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter 
            future={{ 
              v7_startTransition: true
            }}
          >
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </StyledEngineProvider>
    </AuthProvider>
  </React.StrictMode>
);
